import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { UserService } from '@ml/core/services/user.service';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {
  constructor(
    private http: HttpClient,
    private userService: UserService,
    private angularFireMessaging: AngularFireMessaging
  ) {}

  subscribeChangeToken$() {
    return this.angularFireMessaging.tokenChanges.pipe(
      filter(value => value !== this.userService.user.fcmToken),
      switchMap(token => this.userService.setFCMToken(token)),
      catchError(error => of(null))
    );
  }

  /**
   * Request permission for the current user
   */
  requestPermission$() {
    return this.angularFireMessaging.requestToken.pipe(
      filter(value => value !== this.userService.user.fcmToken),
      switchMap(token => this.userService.setFCMToken(token)),
      catchError(error => of(null))
    );
  }
}
